import usePopups from "@/stores/popupsStore"
import { computed } from "vue"
import { defineComponent, Modal, type Popup, type ReactiveComponent } from "vue-utils"

const Popups: ReactiveComponent = () => {
	const popups = usePopups()
	const popup = computed(() => popups.topPopup.value)

	return () => {
		if (!popup.value) {
			return null
		}
		const Content = popup.value.content
		return (
			<Modal
				zIndex={3}
				style={{
					minWidth: `min(${popup.value.width ?? 28}rem, calc(100vw - 4rem))`,
					width: popup.value.width ?? "22.5%",
				}}
				onCancel={(e) => {
					e.preventDefault()
					if (popup.value?.onClose) {
						popup.value.onClose()
						popups.closePopup(popup.value)
					}
				}}
			>
				<Content close={() => popups.closePopup(popup.value as Popup)} popup={popup.value} />
			</Modal>
		)
	}
}

export default defineComponent(Popups)
